export default __webpack_public_path__ + "static/media/cover_image.ccb32e74.JPG";